import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { ReactNode } from "react";
type SliderProps = {
  readonly children: ReactNode;
  readonly activeStep?: number;
};
const fullWidth = 100;
export function Slider(t0) {
  const $ = _c(6);
  const {
    activeStep: t1,
    children
  } = t0;
  const activeStep = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = clsx("flex w-full flex-nowrap justify-stretch gap-1 transition duration-500 ease-in-out sm:duration-700");
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = `translateX(-${activeStep * fullWidth}%)`;
  let t4;
  if ($[1] !== t3) {
    t4 = {
      transform: t3
    };
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== children || $[4] !== t4) {
    t5 = <div className="overflow-x-hidden"><ul className={t2} style={t4}>{children}</ul></div>;
    $[3] = children;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}